/**
 * The reference card that comes in the box: how this game's cards rank and
 * what they score, opened from the hand band and dropped over the felt.
 *
 * It stops short of the hand, which stays lit beneath it, so a player can read
 * their own cards against the order rather than memorise one and then look
 * for the other. A tap anywhere puts it away; it is a glance, not a screen.
 *
 * Portalled to the body: the hand band tilts with the phone (`holdTilt`), and a
 * transformed ancestor would pin a fixed panel to the band instead of the
 * screen.
 */
import { useEffect, type ReactNode } from 'react'
import { createPortal } from 'react-dom'

export function ReferenceCard({ label, onClose, children }: { label: string; onClose: () => void; children: ReactNode }): JSX.Element {
  useEffect(() => {
    const key = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', key)
    return () => window.removeEventListener('keydown', key)
  }, [onClose])
  return createPortal(
    <div className="ref-scrim" onClick={onClose}>
      <div className="ref-card" role="dialog" aria-modal="true" aria-label={label}>
        {children}
        <div className="ref-foot">Tap anywhere to close</div>
      </div>
    </div>,
    document.body,
  )
}
